var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Header),_c(_setup.Search,{attrs:{"search-type":"startups","old-search":true,"customView":"my-startups"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }